export default {
   name: 'LoadingSpinner',
   props: {
      loadingValue: {
         type: Boolean,
         required: true
      }
   },
   data() {
      return {
         loading: false
      }
   },
   watch: {
      loadingValue: {
         immediate: true,
         handler(value) {
            this.loading = value
         }
      }
   }
}
